<template>
    <v-card @click="researchClicked(research)">
        <v-card-text>
            <strong>{{research.reference}} {{research.year}} {{research.abc}}</strong>
            <br>{{ research.notes }}<br v-if="research.notes">
            <v-chip class="continent" v-if="research.inAfrica">{{$t('labels.africa')}}</v-chip>
            <v-chip class="continent" v-if="research.inAmerica">{{$t('labels.america')}}</v-chip>
            <v-chip class="continent" v-if="research.inAsia">{{$t('labels.asia')}}</v-chip>
            <v-chip class="continent" v-if="research.inAustralia">{{$t('labels.oceania')}}</v-chip>
            <v-chip class="continent" v-if="research.inEurope">{{$t('labels.europe')}}</v-chip>

            <v-chip class="anatomic-part" v-if="research.cranium">{{$t('labels.cranium')}}</v-chip>
            <v-chip class="anatomic-part" v-if="research.lowerJaw">{{$t('labels.lowerJaw')}}</v-chip>
            <v-chip class="anatomic-part" v-if="research.teeth">{{$t('labels.teeth')}}</v-chip>
            <v-chip class="anatomic-part" v-if="research.hyoid">{{$t('labels.hyoid')}}</v-chip>
            <v-chip class="anatomic-part" v-if="research.vertebrae">{{$t('labels.vertebrae')}}</v-chip>
            <v-chip class="anatomic-part" v-if="research.ribs">{{$t('labels.ribs')}}</v-chip>
            <v-chip class="anatomic-part" v-if="research.girdles">{{$t('labels.girdles')}}</v-chip>
            <v-chip class="anatomic-part" v-if="research.limbs">{{$t('labels.limbs')}}</v-chip>
            <v-chip class="anatomic-part" v-if="research.osteoderms">{{$t('labels.osteoderms')}}</v-chip>
            <v-chip class="anatomic-part" v-if="research.shell">{{$t('labels.shell')}}</v-chip>

            <v-chip class="variability" v-if="research.intraspecificVariation">{{$t('labels.intraspecificVariation')}}</v-chip>
            <v-chip class="variability" v-if="research.ontogeneticVariation">{{$t('labels.ontogeneticVariation')}}</v-chip>
            <v-chip class="variability" v-if="research.sexDim">{{$t('labels.sexDim')}}</v-chip>

            <v-chip class="data-type" v-if="research.hasDescription">{{$t('labels.hasDescription')}}</v-chip>
            <v-chip class="data-type" v-if="research.hasFigure">{{$t('labels.hasFigure')}}</v-chip>
            <v-chip class="data-type" v-if="research.hasScoring">{{$t('labels.hasScoring')}}</v-chip>
            <v-chip class="data-type" v-if="research.hasGeometricMorphology">{{$t('labels.hasGeometricMorphology')}}</v-chip>
            <v-chip class="data-type" v-if="research.hasFiniteElementsAnalysis">{{$t('labels.hasFiniteElementsAnalysis')}}</v-chip>

            <v-chip class="techniques" v-if="research.drySkeleton">{{$t('labels.drySkeleton')}}</v-chip>
            <v-chip class="techniques" v-if="research.clearingAndStaining">{{$t('labels.clearingAndStaining')}}</v-chip>
            <v-chip class="techniques" v-if="research.ctScan">{{$t('labels.ctScan')}}</v-chip>
            <v-chip class="techniques" v-if="research.xRays">{{$t('labels.xRays')}}</v-chip>
            <v-chip class="techniques" v-if="research.histological">{{$t('labels.histological')}}</v-chip>
        </v-card-text>
    </v-card>
</template>

<script>
const axios = require('axios').default;
export default {
  name: "ResearchCard",
  props: ["researchId"],
  data() {
    return {
        research: {
            reference:null,
            year:null,
            abc:null,
            entryByName:null,
            notes:null
        }
    };
  },
  methods: {
    researchClicked(research){
        let vm = this;
        vm.$router.push({name: 'research', params:{researchId:research.id}});
    },
    async getResearch(){
        let vm = this;
        try {
            const response = await axios({
                method: "GET",
                url: vm.$API_BASE_URL + "researches/getResource.php?researchId="+vm.researchId,
                headers: {
                    'Authentication-Token': window.localStorage.getItem("herp_at")
                }
            });
            if (response.status == 200) {
                vm.research = response.data.resource;
            } 
            else{
                alert(vm.$t('labels.errorLoading'));
            }
        } catch(error) {
            if(error.response && (error.response.status==403||error.response.status==401)){
                vm.$router.push({name: 'login'});
            }
            else{
                alert(vm.$t('labels.errorLoading'));
                console.error(error)
            }
        }
    },
  },
  mounted() {
    let vm = this;
    vm.getResearch();
  },
};
</script>
